import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../config/connect";

const AutomationLevel = ({ onAutomationLevelSelected }) => {
  const [selectedAutomationLevel, setSelectedAutomationLevel] = useState(null);
  const [variations, setVariations] = useState([]);
  const { prodcode } = useParams();

  const getAllProductVariations = async () => {
    try {
      const response = await fetch(
        `https://ghmarkets.net/test/ghmarketconnect/?ghw=productservices&svg=fashionvariations&prcode=${prodcode}`
      );
      const json = await response.json();
      const firstResult = json["results"][0];
      if (firstResult && firstResult.automationlevel) {
        const automationLevelObject = firstResult.automationlevel;
        if (automationLevelObject.trim() !== "") {
          setVariations(automationLevelObject.split(","));
        }
      }
    } catch (error) {
      // Handle error here
    }
  };

  useEffect(() => {
    getAllProductVariations();
  }, [prodcode]);

  const handleAutomationLevelClick = (automationlevel) => {
    setSelectedAutomationLevel(automationlevel);
    onAutomationLevelSelected(automationlevel);
  };

  return variations.length > 0 ? (
    <div
      className="sizes-container"
      style={{ display: "flex", flexDirection: "row" }}
    >
      <span
        style={{
          fontSize: "",
          fontWeight: "bold",
          color: "black",
          marginTop: "12px",
        }}
      >
        Automation Level:
      </span>
      <div className="sizes">
        {variations.map((variation, i) => (
          <div
            key={i}
            className={`size ${selectedAutomationLevel === variation ? "selected" : ""}`}
            onClick={() => handleAutomationLevelClick(variation)}
          >
            {variation}
          </div>
        ))}
      </div>
    </div>
  ) : (
    ""
  );
};

export default AutomationLevel;
